import PropTypes from "prop-types";
import React from "react";

const SearchStatus = ({
  resultsRange,
  totalResults,
  keywords,
  selectedFacets,
  handleFacetDismiss,
}) => {
  const shouldRenderFacets = selectedFacets.length > 0;
  const shouldRenderKeywords = !!keywords;

  const onFacetClick = (value) => {
    handleFacetDismiss(value.id);
  };

  const resultLabel = totalResults === 1 ? "result" : "results";

  const renderSelectedFacets = () => {
    return (
      <div className="search-results__active-facets">
        {/* <span>with filters</span> */}
        <ul>
          {selectedFacets.map((value) => {
            return (
              <li key={value.id}>
                <button className="link" onClick={() => onFacetClick(value)}>
                  <span>{value.name}</span>
                  <svg className="icon">
                    <use xlinkHref="/assets/VelirSite-build/img/svg-sprite.svg#close"></use>
                  </svg>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div className="search-results__status">
      <div className="search-results__status-text">
        <strong>{resultsRange}</strong>&nbsp;
        <span>of</span>&nbsp;
        <strong>{totalResults}</strong>&nbsp;
        <span>{resultLabel}</span>&nbsp;
        {shouldRenderKeywords && <span>for &quot;{keywords ? keywords.replaceAll("\"", "") : ""}&quot;&nbsp;</span>}
      </div>
      {shouldRenderFacets && renderSelectedFacets()}
    </div>
  );
};

const { string, number, object, arrayOf, func } = PropTypes;

SearchStatus.propTypes = {
  resultsRange: string.isRequired,
  totalResults: number.isRequired,
  keywords: string,
  selectedFacets: arrayOf(object).isRequired,
  handleFacetDismiss: func.isRequired,
};

SearchStatus.defaultProps = {
  selectedFacets: [],
};

export default SearchStatus;
